/**
 * window.__sbpCheckout — оплата по СБП «из приложения банка» ОДНИМ способом на
 * все кассы: кнопка, экран ожидания, QR на десктопе, ссылка на телефоне, опрос
 * статуса, таймаут и телеметрия.
 *
 * Почему отдельная кнопка, а не пункт виджета: в виджете ЮKassa СБП свёрнут под
 * «Ещё способы» и лежит НИЖЕ сгиба на телефоне (замер 18.08 на 360×461 —
 * первый экран это SberPay / Банковская карта / ЮMoney / Mir Pay). Настроить
 * состав нельзя: конструктор виджета принимает только confirmation_token,
 * return_url, error_callback и customization.colors — проверено по их бандлу.
 *
 * Логика извлечена из pro/checkout-plus.blade.php (там она была с 06.08 и
 * работает: 17 оплат за 60 дней), а не переписана заново. Копия этой логики в
 * новой кассе — то место, где через месяц починят одну и забудут вторую.
 *
 * Разметку даёт partials/sbp-pay.blade.php; страница подключает поведение:
 *
 *   window.__sbpCheckout.attach('tok', {
 *       start:  function () { … Promise<{sbp_url, payment_id}> },
 *       poll:   function (paymentId) { … Promise<boolean> },   // оплачено?
 *       onPaid: function () { location.href = '/ru/tokens/done'; },
 *       price:  function () { return '99'; },
 *   });
 */
(function () {
    'use strict';

    // ~5 минут: человек уходит в приложение банка, выбирает счёт, подтверждает.
    var MAX_TRIES = 100;
    var STEP_MS = 3000;

    function isPhone() {
        try {
            return window.matchMedia && window.matchMedia('(max-width: 820px)').matches;
        } catch (_) {
            return false;
        }
    }

    function ae(name, data) {
        try { if (window.__ae) window.__ae(name, data || {}); } catch (_) {}
    }

    /** QR рисуем сами, чтобы человек оставался у нас и мы видели момент оплаты. */
    function withQrLib(cb) {
        if (typeof window.QRCode === 'function') { cb(); return; }
        var one = document.createElement('script');
        one.src = '/vendor/qrcode/qrcode.min.js';
        one.onload = function () {
            var two = document.createElement('script');
            two.src = '/vendor/qrcode/qr-adapter.js';
            two.onload = cb;
            two.onerror = cb;      // без QR ссылка всё равно работает
            document.head.appendChild(two);
        };
        one.onerror = cb;
        document.head.appendChild(one);
    }

    var queued = (window.__sbpCheckout && window.__sbpCheckout._q) || [];

    window.__sbpCheckout = {
        /**
         * @param {string} id      префикс разметки из partials/sbp-pay
         * @param {{start:Function, poll:Function, onPaid:Function, price?:Function,
         *          onCancel?:Function, onError?:Function, flow?:string}} opts
         */
        attach: function (id, opts) {
            var box = document.getElementById('sbp-wait-' + id);
            if (!box || !opts) return;
            // Кнопки может не быть: там, где платёж создаёт ФОРМА (витрина-касса),
            // страница вызывает вернувшийся .show(res) сама.
            var btn = document.getElementById('sbp-btn-' + id) || document.createElement('button');
            var ctl = {};

            var qrEl    = box.querySelector('[data-sbp-qr]');
            var openEl  = box.querySelector('[data-sbp-open]');
            var priceEl = box.querySelector('[data-sbp-price]');
            var hintEl  = box.querySelector('[data-sbp-hint]');
            var backEl  = box.querySelector('[data-sbp-back]');
            var errEl   = box.querySelector('[data-sbp-error]');
            var altEl   = box.querySelector('[data-sbp-alt]');
            var flow    = opts.flow || id;

            var timer = null, tries = 0, busy = false, paymentId = null;

            function stopPoll() { if (timer) { clearTimeout(timer); timer = null; } tries = 0; }

            function hide() {
                stopPoll();
                busy = false;
                box.hidden = true;
                if (qrEl) qrEl.innerHTML = '';
                if (errEl) { errEl.textContent = ''; errEl.hidden = true; }
                btn.hidden = false;
                btn.disabled = false;
            }

            function fail(msg) {
                stopPoll();
                busy = false;
                if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
                btn.disabled = false;
            }

            function poll() {
                tries++;
                Promise.resolve(opts.poll(paymentId)).then(function (paid) {
                    if (paid) {
                        stopPoll();
                        ae('sbp_paid', { flow: flow, attempts: tries });
                        opts.onPaid();
                        return;
                    }
                    if (tries >= MAX_TRIES) {
                        ae('sbp_timeout', { flow: flow, attempts: tries });
                        fail('Мы так и не увидели оплату. Если деньги списались — напишите нам, разберёмся.');
                        return;
                    }
                    timer = setTimeout(poll, STEP_MS);
                }, function () {
                    // Сеть моргнула — не считаем это отказом, просто ждём дальше.
                    if (tries < MAX_TRIES) timer = setTimeout(poll, STEP_MS);
                });
            }

            /** Экран ожидания для УЖЕ созданного платежа. */
            function show(res) {
                paymentId = (res && res.payment_id) || null;

                // Страница закрывает свой виджет ДО показа экрана ожидания:
                // два платёжных интерфейса одновременно — приглашение ввести
                // карту, пока мы ждём подтверждения от банка (увидено на живом
                // прогоне 18.08).
                if (opts.onOpen) { try { opts.onOpen(); } catch (_) {} }

                btn.hidden = true;
                box.hidden = false;
                if (priceEl && opts.price) priceEl.textContent = opts.price();
                if (openEl) openEl.href = res.sbp_url;
                if (altEl) altEl.href = res.sbp_url;

                // На телефоне ссылка уводит прямо в выбор банка; на десктопе
                // показываем QR (страница НСПК рисует его и сама, но тогда
                // человек уходит от нас и мы не видим момент оплаты).
                if (isPhone()) {
                    // Телефон: QR не нужен — ссылка уводит прямо в выбор банка.
                    if (hintEl) hintEl.hidden = true;
                    if (qrEl) qrEl.hidden = true;
                    if (openEl) openEl.hidden = false;
                } else {
                    // Десктоп: платят КАМЕРОЙ по QR, поэтому большая кнопка
                    // «Открыть приложение банка» здесь только сбивает — она
                    // ведёт на ту же страницу НСПК с тем же кодом. Оставляем
                    // подпись, что делать, и тихую запасную ссылку.
                    if (hintEl) hintEl.hidden = false;
                    if (openEl) openEl.hidden = true;
                    if (altEl) altEl.hidden = false;
                    if (qrEl) {
                        qrEl.hidden = false;
                        qrEl.innerHTML = '';
                        withQrLib(function () {
                            if (typeof window.QRCode !== 'function') return;
                            try { new window.QRCode(qrEl, { text: res.sbp_url, width: 208 }); } catch (_) {}
                        });
                    }
                }

                tries = 0;
                timer = setTimeout(poll, STEP_MS);
            }
            ctl.show = show;

            btn.addEventListener('click', function () {
                if (busy || typeof opts.start !== 'function') return;
                busy = true;
                btn.disabled = true;
                ae('sbp_start', { flow: flow });

                Promise.resolve(opts.start()).then(function (res) {
                    if (!res || !res.sbp_url) {
                        busy = false;
                        btn.disabled = false;
                        if (opts.onError) opts.onError(res);
                        else fail('Не удалось открыть оплату. Попробуйте ещё раз.');
                        ae('sbp_start_fail', { flow: flow, code: (res && res.error) || 'no_url' });
                        return;
                    }
                    ae('sbp_start_ok', { flow: flow });
                    show(res);
                }, function () {
                    busy = false;
                    btn.disabled = false;
                    ae('sbp_start_fail', { flow: flow, code: 'network' });
                    fail('Сетевая ошибка. Проверьте соединение и попробуйте ещё раз.');
                });
            });

            if (backEl) {
                backEl.addEventListener('click', function () {
                    ae('sbp_back', { flow: flow });
                    hide();
                    if (opts.onCancel) opts.onCancel();
                });
            }

            // Кнопка появляется только когда поведение подключено: мёртвая
            // кнопка на денежной странице хуже её отсутствия.
            if (typeof opts.start === 'function') btn.hidden = false;

            ctl.hide = hide;
            return ctl;
        },
    };

    // Всё, что страница попросила до загрузки файла.
    for (var i = 0; i < queued.length; i++) {
        try { window.__sbpCheckout.attach(queued[i][0], queued[i][1]); } catch (_) {}
    }
})();
